import { createTransform } from "redux-persist";

import { DoubleLinkedList } from "../../../utils/help/linkedList/LinkedList";
import {
  CartItemType,
  CartLoyaltyV2SliceType,
} from "../types/CartLoyaltyV2Types";
import { migratePersistedCartLoyaltyV2State } from "../utils/loyaltyCartHelpers";

export const doubleLinkedListTransform = createTransform<
  CartLoyaltyV2SliceType,
  CartLoyaltyV2SliceType
>(
  // Serialization (state → storage)
  (inboundState) => {
    if (
      inboundState &&
      inboundState.selectedOfferSubItems &&
      inboundState.selectedOfferSubItems instanceof DoubleLinkedList
    ) {
      // If the list is empty, we'll return null to effectively clear the storage
      if (inboundState.selectedOfferSubItems.size === 0) {
        return {
          ...inboundState,
          selectedOfferSubItems: null,
        } as unknown as CartLoyaltyV2SliceType;
      }

      return {
        ...inboundState,
        selectedOfferSubItems: inboundState.selectedOfferSubItems.toArray(),
      } as unknown as CartLoyaltyV2SliceType;
    }

    return inboundState;
  },

  // Deserialization (storage → state)
  (outboundState, key) => {
    if (key === "cartLoyaltyV2") {
      outboundState = migratePersistedCartLoyaltyV2State(outboundState);

      // Handle three cases:
      // 1. Value is null/undefined (cleared state)
      // 2. Value is an array (restore from storage)
      // 3. Value is already a DoubleLinkedList (shouldn't normally happen)

      if (
        outboundState.selectedOfferSubItems === null ||
        outboundState.selectedOfferSubItems === undefined
      ) {
        return {
          ...outboundState,
          selectedOfferSubItems: new DoubleLinkedList<CartItemType>(),
        };
      }

      if (Array.isArray(outboundState.selectedOfferSubItems)) {
        const restoredList = new DoubleLinkedList<CartItemType>();
        outboundState.selectedOfferSubItems.forEach((item: CartItemType) =>
          restoredList.append(item)
        );

        return {
          ...outboundState,
          selectedOfferSubItems: restoredList,
        };
      }
    }

    return outboundState;
  }
);

export const loadingResetTransform = createTransform<
  CartLoyaltyV2SliceType,
  CartLoyaltyV2SliceType
>(
  // Don't modify state when saving to storage
  (inboundState) => inboundState,
  // Reset loading states when rehydrating from storage
  (outboundState: any, key) => {
    // Only modify the properties we care about
    if (key === "isLoading") {
      return false;
    }

    if (key === "pendingOperations") {
      return 0;
    }

    // For all other properties, return them unchanged
    return outboundState;
  }
);
